var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersActivityActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50305 0C7.01177 0 4.99219 2.00972 4.99219 4.48886C4.99219 6.96801 7.01177 8.97772 9.50305 8.97772C11.9944 8.97772 14.014 6.96801 14.014 4.48886C14.014 2.00972 11.9944 0 9.50305 0V0Z",
    fill: "#8B8B8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8172 19.0962C14.7803 19.1138 14.7391 19.1318 14.6932 19.1505C13.0789 19.8078 10.9593 20 8.8141 20C6.65551 20 4.53472 19.8004 2.92213 19.1344C2.1042 18.7966 1.36654 18.3186 0.832036 17.6383C0.286748 16.9442 0 16.0986 0 15.1225C0 14.1451 0.289177 13.3 0.838009 12.6082C1.37555 11.9306 2.11626 11.457 2.93494 11.1236C4.54919 10.4661 6.66876 10.2737 8.8141 10.2737C10.1921 10.2737 11.5546 10.355 12.7792 10.587L9.87372 14.9158C9.65659 15.2393 9.62756 15.6649 9.79859 16.0184C9.96949 16.3719 10.3118 16.5942 10.6853 16.5942H14.8172V19.0962Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6014 8.33154L12.3379 14.6836H16.7367V19.3374L21.0001 12.9854H16.6014V8.33154Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersActivityActive);
export default __webpack_public_path__ + "static/media/usersActivityActive.c69596267d4ece76ebab8a5db7920ab9.svg";
export { ForwardRef as ReactComponent };